import React, { Component } from "react";

import { Formik, Form } from "formik";
import {
	SelectInput,
	IconTextInput,
	CheckboxInput,
} from "../../../../forms/components";

import { addNewRates } from "../../../../libs/functions";

import Swal from "sweetalert2";
import Util from "../../../../libs/util";

class ManageNewMerchantRates extends Component {
	constructor(props) {
		super(props);

		this.state = {
			config: props.config,
			paymentTypes: Object.keys(props.MDRTypes),
			initialValues: {
				code: "",
			},
			targetBaseRate: null,
		};

		this.newRatesModalRef = React.createRef();
	}

	componentDidUpdate(prevProps) {
		if (
			JSON.stringify(prevProps.config) !== JSON.stringify(this.props.config)
		) {
			this.setState({
				config: this.props.config,
			});
		}
	}

	getGatewayName = (gateway) => {
		if (gateway === "tctp") return "2C2P";
		if (gateway === "uqpay") return "UQPay";
		if (gateway === "stripe") return "Stripe";
		if (gateway === "ipay88") return "iPay88";
		if (gateway === "rms") return "RMS";
		if (gateway === "ghlth") return "GHLTH";
		if (gateway === "netzme") return "Netzme";

	};

	getMdrs = (targetCurrency) => {
		const { MDRTypes, baseRate, config } = this.props;
		let mdrs = {};
		if (config) {
			let targetRates = Object.entries(baseRate[config.gateway]);
			let result = targetRates.reduce((acc, [currency, mdr]) => {
				if (currency === targetCurrency) {
					const filtered = Object.keys(MDRTypes).reduce((acc, paymentType) => {
						if (mdr[paymentType]) acc[paymentType] = mdr[paymentType];
						return acc;
					}, {});

					acc = filtered;
				}
				return acc;
			}, {});
			mdrs = result;
		}
		return mdrs;
	};

	getMdrsEnable = (targetCurrency) => {
		const { MDRTypes, baseRate, config } = this.props;
		let mdrs_enable = {};
		if (config) {
			const result = Object.keys(MDRTypes).reduce((result, key) => {
				if (baseRate?.[config.gateway]?.[targetCurrency]?.[key])
					result[key] = true;
				return result;
			}, {});
			mdrs_enable = result;
		}
		return mdrs_enable;
	};

	selectCurrency = (value) => {
		if (value) {
			let mdrs = this.getMdrs(value);
			let mdrs_enable = this.getMdrsEnable(value);

			let update = {
				...this.state.initialValues,
				code: value,
				rates: mdrs,
				enable: mdrs_enable,
			};
			this.setState({ targetBaseRate: mdrs, initialValues: update });
		} else {
			this.setState({ targetBaseRate: null, initialValues: { code: "" } });
		}
	};

	closeModal = () => {
		return Util.hideModal("manage-new-rates").then(() => {
			this.newRatesModalRef.current.remove();
		});
	};

	addRates = (values, { resetForm }) => {
		Swal.fire({
			title: "Adding new rates",
			onBeforeOpen: () => {
				this.closeModal().then(() => {
					resetForm({ code: "" });
				});
				Swal.showLoading();
			},
			onOpen: async () => {
				try {
					const { merchant } = this.props;
					const { config } = this.state;
					let status = await addNewRates({
						merchant: merchant.id,
						gateway: config.gateway,
						...values,
					});
					if (status) {
						Swal.fire({
							icon: "success",
							title: "Rates Added",
						}).then(async () => {
							this.props.retrieveMerchants(true);
						});
					}
				} catch (err) {
					Swal.fire({
						icon: "error",
						title: `Unable to add new rates`,
						onClose: () => {},
					});
				}
			},
		});
	};

	render() {
		const { MDRTypes } = this.props;
		const { config, paymentTypes, initialValues, targetBaseRate } = this.state;
		return (
			<div
				id="manage-new-rates"
				className="uk-modal-container"
				uk-modal="stack: true"
				ref={this.newRatesModalRef}
			>
				{config && (
					<div className="uk-modal-dialog uk-modal-body">
						<h2 className="uk-modal-title">
							Add Transaction Fees for {this.getGatewayName(config.gateway)}
						</h2>
						<Formik
							initialValues={initialValues}
							enableReinitialize={true}
							onSubmit={this.addRates}
						>
							{(props) => {
								return (
									<Form onSubmit={props.handleSubmit}>
										<SelectInput
											label="Currency"
											data={config.availableCurrency}
											id={`code`}
											name={`code`}
											initialEmpty={true}
											handleChange={this.selectCurrency}
										/>
										{targetBaseRate && (
											<div className="new-merchant-rate-table uk-overflow-auto uk-margin-bottom">
												<table className="uk-table uk-table-striped uk-table-middle">
													<thead>
														<tr>
															<th>Payment Type</th>
															<th>Local Card</th>
															<th>Overseas Card</th>
															<th className="uk-width-1-6">Enabled</th>
														</tr>
													</thead>
													<tbody>
														{paymentTypes.map((type) => {
															let paymentRate = targetBaseRate[type];
															let enable = props.values.enable
																? !props.values.enable[type]
																: false;
															if (paymentRate)
																return (
																	<tr key={`${type}-rate`}>
																		<td>
																			<img
																				className="uk-img"
																				src={`data:image/*;base64,${MDRTypes[type].image}`}
																				width="35"
																			/>
																			<span className="uk-margin-small-left">
																				{MDRTypes[type].label}
																			</span>
																		</td>
																		<td>
																			<IconTextInput
																				id={`rates.${type}.local.percent`}
																				name={`rates.${type}.local.percent`}
																				icon="fa-solid-percent; ratio: 0.5"
																				iconFlip={true}
																				type="number"
																				step=".01"
																				min={paymentRate.local.percent}
																				placeholder="Local"
																				disabled={enable}
																			/>
																		</td>
																		<td>
																			<IconTextInput
																				id={`rates.${type}.overseas.percent`}
																				name={`rates.${type}.overseas.percent`}
																				icon="fa-solid-percent; ratio: 0.5"
																				iconFlip={true}
																				type="number"
																				step=".01"
																				min={paymentRate.overseas.percent}
																				placeholder="Overseas"
																				disabled={enable}
																			/>
																		</td>
																		<td className="uk-width-1-6 uk-text-center">
																			<CheckboxInput
																				id={`enable.${type}`}
																				name={`enable.${type}`}
																			/>
																		</td>
																	</tr>
																);
														})}
													</tbody>
												</table>
											</div>
										)}
										<p className="uk-text-right">
											<button
												className="uk-button uk-button-default uk-modal-close"
												type="button"
											>
												Cancel
											</button>
											<button
												className="uk-button uk-button-primary"
												type="submit"
											>
												Add
											</button>
										</p>
									</Form>
								);
							}}
						</Formik>
					</div>
				)}
			</div>
		);
	}
}

export default ManageNewMerchantRates;
